import { Component, Element, Host, Prop, h } from '@stencil/core';

import dynamicEntryActions from '../../../actions/actions.dynamic-entry';
import EventBus from '../../../services/service.eventBus';
import { MISMATCH_ERROR, MISMATCH_VIN_LP_ERROR, VIN_LENGTH } from '../../../utils/utils.dynamic-entry';
import { DynamicEntryStartButton } from '../DynamicEntryStartButton';

@Component({
  tag: 'dynamic-entry-vin-modal',
  styleUrl: 'dynamic-entry-vin-modal.css',
})
export class DynamicEntryVinModal {
  @Element() el: HTMLElement;
  @Prop() mismatched: boolean = false;
  @Prop() vin: string = '';
  @Prop() hasVinOrLPError: boolean = false;

  componentDidLoad() {
    this.showModal();
  }

  showModal() {
    this.getModal()?.open();
  }

  getModal() {
    return this.el.querySelector('ico-modal#vin-modal') as HTMLIcoModalElement;
  }

  handleSubmit = async () => {
    await dynamicEntryActions.onTryAgainClick();
  };

  onInputChange(event: CustomEvent<string>) {
    const inputVin = event.detail.trim().toUpperCase();
    dynamicEntryActions.onStoreUpdate({ inputVin });
  }

  onNewOfferClick() {
    EventBus.publish('VinModalNewOfferClick', {});
    this.closeModal();
  }

  closeModal() {
    this.getModal()?.close();
    this.emitCloseEvent();
  }

  emitCloseEvent() {
    EventBus.publish('VinModalClosed', {});
  }

  disconnectedCallback() {
    this.closeModal();
  }

  render() {
    const hasError = this.hasVinOrLPError || this.mismatched;
    return (
      <Host>
        <ico-modal dataTestId="vin" id="vin-modal" callback={() => this.emitCloseEvent()} displayX={false} shouldCloseOnBackdrop={false}>
          <h1 class="dynamic-entry-vin-modal-heading font-semibold text-2xl mt-4" slot="header">
            Enter VIN
          </h1>
          <input-text-box testId="vin-modal-entry" label="VIN" hasError={hasError} onValueChange={(e) => this.onInputChange(e)} value={this.vin} maxLength={VIN_LENGTH} />

          {hasError && (
            <div class="dynamic-entry-vin-modal-error flex text-sm mt-1 md:max-w-sm">
              <svg-icon icon="icon-alert" width="1.5em" height="1.5em" class="mr-2"></svg-icon>
              {this.hasVinOrLPError && MISMATCH_VIN_LP_ERROR}
              {this.mismatched && MISMATCH_ERROR}
            </div>
          )}

          <div class="flex justify-between mt-4 gap-2 md:gap-6 vin-modal-button-group">
            <DynamicEntryStartButton
              class="w-full"
              label={this.mismatched ? 'Try Again' : 'Save'}
              whenClicked={() => this.handleSubmit()}
              color={this.mismatched ? 'tertiary' : 'primary'}
              data-testid={`bi-btn-${this.mismatched ? 'try-again' : 'save'}`}
            />
            {this.mismatched && <DynamicEntryStartButton data-testid="bi-btn-new-offer" class="w-full" label="New Offer" whenClicked={() => this.onNewOfferClick()} />}
          </div>
        </ico-modal>
      </Host>
    );
  }
}
